import React from 'react';
import { Link } from 'react-router-dom';
import { NewsletterForm } from './NewsletterForm';

export function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img 
                src="/logo.png" 
                alt="Congroup Logo" 
                className="h-16 w-auto mb-4"
              />
            </div>
            <p className="text-gray-300 mb-6">
              Soluciones profesionales de consultoría empresarial.
            </p>
            <NewsletterForm variant="inline" />
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/nosotros" className="text-gray-300 hover:text-white transition-colors">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-300 hover:text-white transition-colors">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-white transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Recursos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/medios" className="text-gray-300 hover:text-white transition-colors">
                  Medios
                </Link>
              </li>
              <li>
                <Link to="/boletines" className="text-gray-300 hover:text-white transition-colors">
                  Boletines
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-400">
          <p>&copy; 2026 Congroup SAS Consultores. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}